import * as LoadInformationPermitFields from '@src/permitField/LoadInformationFields';
import * as OverallDimensionsPermitFields from '@src/permitField/OverallDimensionsFields';
import { BooleanField, Field } from '@src/permitField/PermitFields';
import { JurisdictionField } from '@src/permitTypesManager/permitTypeSections/PermitDefinitionFields';
import * as yup from 'yup';

export class LoadModelField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadModelField.fieldName;
}

export class LoadMakeField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadMakeField.fieldName;
}

export class LoadQuantityField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadQuantityField.fieldName;
}

export class LoadYearField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadYearField.fieldName;
}

export class LoadDescriptionField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadDescriptionField.fieldName;
}

export class LoadLoadingMethodField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadLoadingMethod.fieldName;
}
export class SingleItemField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadIsSingleItemField.fieldName;
}

export class LoadSideBySideCount extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadSideBySideCountField.fieldName;
}

export class LoadEndToEndCount extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadEndToEndCountField.fieldName;
}

export class LoadStackCountField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadStackCountField.fieldName;
}

export class LoadDispositionField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadDispositionField.fieldName;
}

export class LoadIsNewlyManufacturedField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadIsNewlyManufacturedField.fieldName;
}

export class LoadIndustryTypeField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadIndustryTypeField.fieldName;
}

export class LoadSerialNumberField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadSerialNumberField.fieldName;
}

export class LoadOwnerNameField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadOwnerNameField.fieldName;
}

export class LoadOwnerAddressField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadOwnerAddressField.fieldName;
}

export class LoadWeightField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadWeightField.fieldName;
}

export class LoadFloridaPermitTypeField extends Field {
  public static fieldName: string =
    LoadInformationPermitFields.FloridaPermitTypeField.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'FL',
      then: (schema) => schema.required(),
    });
}

export class LoadFloridaDescriptionField extends Field {
  public static fieldName: string =
    LoadInformationPermitFields.FloridaLoadDescriptionField.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'FL',
      then: (schema) => schema.required(),
    });
}

export class LoadFloridaIdentityField extends Field {
  public static fieldName: string =
    LoadInformationPermitFields.FloridaLoadIdentityField.fieldName;
  public static validator = yup
    .boolean()
    .default(false)
    .transform((value) => (!value ? false : value))
    .when(JurisdictionField.fieldName, {
      is: 'FL',
      then: (schema) => schema.required(),
    });
}

export class LoadWidthField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadWidthField.fieldName;
}

export class LoadHeightField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadHeightField.fieldName;
}

export class LoadLengthField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadLengthField.fieldName;
}

export class FrontOverhangField extends BooleanField {
  public static fieldName: string =
    OverallDimensionsPermitFields.OverallFrontOverhangField.fieldName;
}

export class RearOverhangField extends BooleanField {
  public static fieldName: string =
    OverallDimensionsPermitFields.OverallRearOverhangField.fieldName;
}

export class EFFOverhangField extends BooleanField {
  public static fieldName: string =
    OverallDimensionsPermitFields.OverallEFFOverhangField.fieldName;
}

export class OverallLengthField extends BooleanField {
  public static fieldName: string =
    OverallDimensionsPermitFields.OverallLengthField.fieldName;
}

export class OverallHeightField extends BooleanField {
  public static fieldName: string =
    OverallDimensionsPermitFields.OverallHeightField.fieldName;
}

export class OverallWidthField extends BooleanField {
  public static fieldName: string =
    OverallDimensionsPermitFields.OverallWidthField.fieldName;
}

export class OverallWeightField extends BooleanField {
  public static fieldName: string =
    OverallDimensionsPermitFields.OverallWeightField.fieldName;
}

export class LoadSealedContainerNumberField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadSealedContainerNumberField.fieldName;
}

export class LoadSealedContainerChassisNumberField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.LoadSealedContainerChassisNumberField.fieldName;
}

export class CommodityField extends BooleanField {
  public static fieldName: string =
    LoadInformationPermitFields.CommodityField.fieldName;
}
